import React from "react";
import { useSelector } from "react-redux";
import { CiUser } from "react-icons/ci";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

type DiscussCommentModalProps = {
  loading: boolean;
  setOnChange: React.Dispatch<React.SetStateAction<boolean>>;
  onChange: boolean;
  communityComment: any;
  setCommunityComment: React.Dispatch<React.SetStateAction<string>>;
  handleSubmit: any;
  textArea: React.MutableRefObject<HTMLTextAreaElement | null>;
};
const DiscussCommentModal: React.FC<DiscussCommentModalProps> = ({
  loading,
  setOnChange,
  onChange,
  communityComment,
  setCommunityComment,
  handleSubmit,
  textArea,
}) => {
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const inputValue = e.target.value.trim();
    setCommunityComment(e.target.value);
    if (inputValue.trim().length > 0) {
      setOnChange(true);
    } else {
      setOnChange(false);
    }
  };

  const user = useSelector((state: any) => state.user.userDetails);

  let _profileImage: string | null = "";

  if (
    user &&
    user?.ecobookProfile &&
    user.ecobookProfile?.profileImage !== null
  ) {
    const profilePic = user?.ecobookProfile?.profileImage;

    if (profilePic !== null && profilePic !== undefined) {
      _profileImage = profilePic;
    }
  }

  return (
    <div className="lg:hidden w-full justify-between flex bg-white px-4 py-2">
      {/* <img src={Astro} alt="" className="w-[34px] h-[34px] rounded-full" /> */}
      {_profileImage ? (
        <img
          alt=""
          src={ipfsGatewayImage(_profileImage!)}
          className="lg:h-11 lg:w-11 w-[34px] h-[34px] rounded-full"
        />
      ) : (
        <div className="lg:h-11 lg:w-11 w-[34px] h-[34px] bg-slate-100 flex items-center justify-center rounded-full">
          <CiUser size={15} />
        </div>
      )}
      <form className="relative w-[86%] sm:md:w-[92%]" onSubmit={handleSubmit}>
      <textarea
          ref={textArea}
          value={communityComment}
          onChange={handleOnChange}
          placeholder="Add a comment..."
          className={`w-full pt-[9px] h-[34px] pl-[20px] pr-[50px] outline-none items-center block font-Poppins text-[10px] j font-normal text-[#646464] rounded-full border text-pretty resize-none ${
            loading ? "disabled:bg-blend-overlay" : ""
          }`}
          disabled={loading}
        />

        <input
          type="submit"
          value="Post"
          className={`${
            onChange
              ? "absolute cursor-pointer visible right-6 top-[8.5px] text-midGreen text-xs font-Poppins font-normal"
              : "hidden"
          }`}
          disabled={loading}
        />

        {/* {loading && (
        <input
          type="button"
          disabled
          value="Post"
          className="absolute right-6 top-[8.5px] text-lightGreyText text-xs font-Poppins font-normal"
        />
      )} */}
      </form>
    </div>
  );
};

export default DiscussCommentModal;
